import { useIntl } from "react-intl";

export function useLocale() {
    const intl = useIntl();
    return intl.locale;
}
